import { render, staticRenderFns } from "./addOrgDialog.vue?vue&type=template&id=c5bfbd4e&scoped=true"
import script from "./addOrgDialog.vue?vue&type=script&lang=js"
export * from "./addOrgDialog.vue?vue&type=script&lang=js"
import style0 from "./addOrgDialog.vue?vue&type=style&index=0&id=c5bfbd4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5bfbd4e",
  null
  
)

export default component.exports